<div class="calendar-events-sidenav">
  <sidenav-loading *ngIf="service.calendarViewCtrl.loading" [cover]="true"></sidenav-loading>
  <div class="calendar-events-sidenav__details">
    <sidenav-title
      [title]="'Calendar.thisWeekTitle' | translate: { time: weekStart | rangeFormat: weekEnd:true }"
    ></sidenav-title>
    <calendar-events-list></calendar-events-list>
  </div>
</div>
